import { Badge, Box, HStack, Heading, ListItem, Text } from "@chakra-ui/react";
import { BsDatabaseFillUp } from "react-icons/bs";
import type { CompanyProcessListItem } from "./types";
import { CompanyStatus } from "@companies/types/company";

const CompanyProcessListItem = ({item, isSelected, onSelectItem}:CompanyProcessListItem) => {
    return (
        <ListItem
            w="100%"
            pl={4}
            py={2}
            bg={`${isSelected ? 'gray.100': 'white'}`}
            borderLeftRadius={isSelected ? 24 : 0}
            cursor="pointer"
            _hover={{bg: "gray.100", borderLeftRadius: 24}}
            onClick={() => onSelectItem(item)}
        >
            <HStack w="100%"  justifyContent="start" alignContent="center" spacing={2}>
                <Badge bg={item.estatus === CompanyStatus.Activado ? "green.200" : "red.200"} w="0.5rem" h="0.5rem" borderRadius="100%"/>
                <Box w="2rem" h="2rem">
                    <BsDatabaseFillUp size="2rem" color="teal"/>
                </Box>
                <Box>
                    <Heading as="h4" fontSize="sm" fontWeight={600} noOfLines={1}>{item.nombre}</Heading>
                    <Text fontSize="xs" noOfLines={1}>{item.nombre}</Text>
                </Box>
            </HStack>
        </ListItem>
    )
}

export default CompanyProcessListItem;
